import { GetServerSideProps } from "next";
import ProcedureListingContainer from "../../containers/ProcedureListingContainer";
import { initializeApollo } from "../../graphql/client";

export const getServerSideProps: GetServerSideProps = async (context) => {
  const apolloClient = initializeApollo();

  await ProcedureListingContainer.runDataQueries(context, apolloClient);

  return {
    props: { initialApolloState: apolloClient.cache.extract() },
  };
};

export default function IndustryIndexPage() {
  return <ProcedureListingContainer />;
}
